import { FilterModal, SearchFilter, StatusFilter } from '@synergy/components';
import { FormattedMessage } from 'react-intl';
import { ImportSupplierStatus } from '@synergy/models';

import { ReceptionTypeFilter } from './reception-type-filter';

export const ImportSupplierFilter = () => {
    return (
        <>
            <FilterModal title={<FormattedMessage id="app.imports.detail.filterTitle" />}>
                <StatusFilter
                    documentStatus={[
                        ImportSupplierStatus.OnSchedule,
                        ImportSupplierStatus.Overdue,
                        ImportSupplierStatus.NoInterval,
                    ]}
                />
                <ReceptionTypeFilter />
            </FilterModal>
            <SearchFilter />
        </>
    );
};
